export const selections = [
  [
    {
      number: "1",
      numberColor: "#FFFFFF",
      saddleColor: "#BC0000"
    },
    {
      number: "1A",
      numberColor: "#FFFFFF",
      saddleColor: "#BC0000"
    },
    {
      number: "4",
      numberColor: "#000000",
      saddleColor: "#C1A800"
    }
  ],
  [
    {
      number: "1",
      numberColor: "#FFFFFF",
      saddleColor: "#BC0000"
    },
    {
      number: "1A",
      numberColor: "#FFFFFF",
      saddleColor: "#BC0000"
    }
  ]
];

export const selectionsNbr = [
  ["1", "1A", "4"],
  ["1", "1A"]
];
